import type { CreateClientConfig } from '../generated/client.gen';
import { timeoutFetch } from './timeoutFetch';

/**
 * Applied by the generated `client.gen.ts` when it constructs the client, so these values are in place
 * before any caller can reach the SDK. That ordering is load-bearing, not stylistic: the generated
 * client defaults `baseUrl` to the spec's dev server, and TanStack query keys embed
 * `client.getConfig().baseUrl` at call time — configuring later would split the cache between keys
 * built before and after, and let stray absolute requests through that MSW's `*` handlers still match.
 *
 * Interceptors cannot live here (this module is imported *by* `client.gen.ts`); they are registered by
 * `installInterceptors()` at app bootstrap.
 */
export const createClientConfig: CreateClientConfig = (config) => ({
  ...config,
  baseUrl: typeof window === 'undefined' ? '' : window.location.origin,
  credentials: 'include',
  fetch: timeoutFetch,
  // Throw on non-2xx by default so a direct SDK call that forgets `throwOnError: true` still surfaces an
  // ApiError (via the error interceptor) instead of silently returning `{ data: undefined }`. The generated
  // query/mutation factories set it explicitly, so this only backstops hand-written call sites.
  throwOnError: true,
});
